import { ABTastyUA, TagData } from '@src/application/modules/tag/shared/tag/serializedTagTypes';
import { ApiCurrentUser, FlagShipModificationValues } from '@abtasty/api-client';
import { AsyncState } from 'react-use/lib/useAsyncFn';

export enum Access {
  loading = 'loading',
  pass = 'pass',
  failedSigningIn = 'failedSigningIn',
  unauthorized = 'unauthorized',
  forbidden = 'forbidden',
}
export enum Scope {
  full = 'full',
  withCode = 'withCode',
}

export type TagContextValue = { loading: boolean; tagData: TagData | null };
export type AccountContextValue = {
  loading: boolean;
  accountId?: number;
  accountName: string;
  ABTastyUA: ABTastyUA;
  flagship: Partial<FlagShipModificationValues>;
  fetchAccountInfo: (accountId: number) => Promise<void>;
  packageName: string;
};

export type UserContextValue = AccessState & {
  profile?: AsyncState<ApiCurrentUser>;
};

export type AccessState = {
  access: Access;
  scope?: Scope;
};

export type AccessReducerAction =
  | { type: 'SIGN_IN_WITH_CODE_REQUEST' }
  | { type: 'SIGN_IN_WITH_CODE_FAILURE' }
  | { type: 'FORBIDDEN' }
  | { type: 'UNAUTHORIZED' }
  | { type: 'CHECK_ACCOUNT_ACCESS_REQUEST'; scope: Scope }
  | { type: 'CHECK_ACCOUNT_ACCESS_FAILURE' }
  | { type: 'CHECK_ACCOUNT_SUCCESS' };
